"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Cta() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="cta" data-nav="light" className="relative border-t border-border bg-background py-16 sm:py-20 lg:py-24">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
        <motion.div initial={{
        opacity: 0,
        y: shouldReduceMotion ? 0 : 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.35,
        ease: [0.16, 1, 0.3, 1]
      }} className="relative border border-border bg-card p-8 sm:p-12 lg:p-16">
          {/* Machined datum registration marks in corners */}
          <div aria-hidden="true" className="pointer-events-none absolute -top-1.5 -left-1.5 size-3 border-t-2 border-l-2 border-foreground" />
          <div aria-hidden="true" className="pointer-events-none absolute -top-1.5 -right-1.5 size-3 border-t-2 border-r-2 border-foreground" />
          <div aria-hidden="true" className="pointer-events-none absolute -bottom-1.5 -left-1.5 size-3 border-b-2 border-l-2 border-foreground" />
          <div aria-hidden="true" className="pointer-events-none absolute -bottom-1.5 -right-1.5 size-3 border-b-2 border-r-2 border-foreground" />

          <div className="mx-auto max-w-3xl text-center">
            {/* Eyebrow */}
            <p className="font-mono text-xs sm:text-sm font-semibold uppercase tracking-widest text-primary">
              EQUIPMENT SELECTION
            </p>

            {/* Headline */}
            <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl font-bold uppercase tracking-tight text-foreground">
              Find the Mechanical Bull That Fits Your Operation
            </h2>

            {/* Supporting Copy */}
            <p className="mt-4 text-base sm:text-lg leading-relaxed text-muted-foreground">
              The right machine is the one that fits your intended use, available
              space, equipment requirements and budget. Compare the complete package
              rather than choosing from price or appearance alone.
            </p>

            <p className="mt-3 text-base sm:text-lg leading-relaxed text-muted-foreground">
              Browse the current new and used mechanical bulls, or contact us with
              the model you are considering if you need clarification about the
              information available for that listing.
            </p>

            {/* Action Buttons */}
            <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row sm:flex-wrap">
              <Button asChild className="w-full sm:w-auto border border-primary bg-primary px-8 py-3.5 font-serif text-base font-semibold uppercase tracking-wider text-primary-foreground shadow-xs transition-[background-color,border-color] hover:border-primary/90 hover:bg-primary/90">
                <Link to="/NewMechanicalBullsPage">
                  <span>View New Bulls</span>
                  <ArrowRight className="size-4" />
                </Link>
              </Button>

              <Button asChild variant="outline" className="w-full sm:w-auto border border-foreground bg-transparent px-8 py-3.5 font-serif text-base font-semibold uppercase tracking-wider text-foreground shadow-xs transition-[background-color,color] hover:bg-foreground hover:text-background">
                <Link to="/UsedMechanicalBullsPage">
                  <span>View Used Bulls</span>
                </Link>
              </Button>

              <Button asChild variant="outline" className="w-full sm:w-auto border border-border bg-muted/60 px-8 py-3.5 font-serif text-base font-semibold uppercase tracking-wider text-foreground shadow-xs transition-[background-color,border-color] hover:border-foreground hover:bg-muted">
                <Link to="/ContactPage">
                  <span>Contact Us</span>
                </Link>
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}